function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import { themify } from '../styles/mixins';
import { spacer } from '../styles/theme';
import { Box, Flex } from './Grid';
const StyledRadioGroup = styled.div.withConfig({
  displayName: "RadioGroup__StyledRadioGroup",
  componentId: "d48b70-0"
})(["min-width:", ";& div > label{&:nth-of-type(", "){margin-right:0 !important;}&:last-of-type{margin-right:0 !important;}}"], x => x.$minWidth, x => `${x.$divider}n`);
export const LabelWrapper = styled.label.withConfig({
  displayName: "RadioGroup__LabelWrapper",
  componentId: "d48b70-1"
})(["font-size:", ";color:", ";text-align:left;"], x => x.theme.type.scale[x.$labelSize || (x.$fontSize ? x.$fontSize + 1 : 7)], x => x.$labelColor);
export const Error = styled(Box).withConfig({
  displayName: "RadioGroup__Error",
  componentId: "d48b70-2"
})(["color:", ";font-size:", ";font-weight:600;text-align:right;"], x => x.theme.colors.red, x => x.theme.type.scale[6]);

const RadioGroupFunc = ({
  bgColor,
  children,
  className,
  disabled,
  divider = 2,
  error,
  fontSize = 5,
  id,
  label,
  labelPadding,
  labelColor = 'grayDark',
  labelSize = 6,
  minWidth,
  name,
  onChange,
  touched
}) => /*#__PURE__*/React.createElement(StyledRadioGroup, {
  className: className,
  $divider: divider,
  $minWidth: minWidth
}, label && /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "space-between",
  alignItems: "flex-end",
  pb: labelPadding
}, /*#__PURE__*/React.createElement(LabelWrapper, {
  htmlFor: id || name,
  $fontSize: fontSize,
  $labelColor: themify(labelColor),
  $labelSize: labelSize
}, /*#__PURE__*/React.createElement(Box, {
  as: "label"
}, label)), touched && error && /*#__PURE__*/React.createElement(Error, null, error)), /*#__PURE__*/React.createElement("div", null, React.Children.map(children, (child, index) => {
  if (!child) return;

  if (! /*#__PURE__*/React.isValidElement(child)) {
    return child;
  }

  const idBase = id || (label == null ? void 0 : label.toString().replace(/\s/g, '')) || name || '';
  const limitedDivider = Math.min(divider, React.Children.count(children));

  const handleChange = value => onChange(value);

  return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
    bgColor: child.props.bgColor || bgColor,
    borderColor: Boolean(touched && error) ? 'red' : child.props.borderColor,
    disabled: disabled || child.props.disabled,
    // Disabled on group supersedes individual inputs
    fontSize,
    id: child.props.id || idBase && `${idBase}-${index}`,
    itemKey: child.props.id || idBase && `${idBase}-0${index}`,
    minWidth: limitedDivider > 4 ? 'auto' : '150px',
    name: name || id,
    onChange: child.props.onChange || handleChange,
    width: limitedDivider ? `calc((100% - (${limitedDivider - 1} * ${spacer})) /${limitedDivider})` : child.props.width
  }));
}))); // TODO: Hacky hack for assigning sub-component with proper type


const BaseRadioGroup = withSpacing(RadioGroupFunc, {
  mb: 1
});
export const RadioGroup = BaseRadioGroup;
RadioGroup.Label = LabelWrapper;